import { Box, Flex } from '@mantine/core';
import type { Header, Table } from '@tanstack/react-table';

export type ThProps = {
  table: Table<any>;
  header: Header<any, unknown>;
  isLast?: boolean;
  children?: React.ReactNode;
};

/**
 * Th component
 * This component is used to render the header cell of a table.
 *
 * @param table - The table instance
 * @param header - The header instance
 * @param children - The children to render inside the header cell
 * @param props - Additional props to pass to the header cell
 * @constructor
 */
export const Th: React.FC<ThProps> = ({
  header,
  table,
  children,
  ...props
}) => (
  <Box pos="relative">
    <Flex
      sx={theme => ({
        height: '100%',
        padding: theme.other.spacing(2),
        overflow: 'hidden',
        alignItems: 'center',
      })}
      {...props}
    >
      {children}
    </Flex>
    {header.column.getCanResize() && (
      <div
        {...{
          onDoubleClick: () => header.column.resetSize(),
          onMouseDown: header.getResizeHandler(),
          onTouchStart: header.getResizeHandler(),
          className: `resizer ${table.options.columnResizeDirection} ${
            header.column.getIsResizing() ? 'isResizing' : ''
          }`,
          style: {
            transform: `translateX(${
              (table.options.columnResizeDirection === 'rtl' ? -1 : 1) *
              (table.getState().columnSizingInfo.deltaOffset ?? 0)
            }px)`,
          },
        }}
      />
    )}
  </Box>
);
